angular.module("parkingFormApp.constants")
.constant("EnvironmentConfig", {"stripeKey":"pk_live_jUooxkLILXV1ba8cij4XNqJu","environment":"production"});



// WEBPACK FOOTER //
// ./client/app/configFile.js